import { Cobertura, CurrencyCode, FILE_TYPES, PaymentMethodForms, Version, WebHomeQuotation } from "../../../../../shared/interfaces";
import {
  Activity,
  AppliedCharacteristics,
  Budget,
  Coverage,
  DiscountsAndSurcharges,
  Holding,
  QuotationContextData,
  QuotePdfServiceRequest,
} from "../../../../../shared/interfaces/services/quote-pdf-service";
import QuotationService from "../../../../../shared/services/quotation";
import { downloadBase64Files, formattedPrice } from "../../../../../shared/utils";
import {
  BranchDocumentsURL,
  BudgetType,
  CarCoverageInundacionFranchiseExempt,
} from "./quotation-documents.enum";
import dayjs from "dayjs";

export const getQuoteDocumentPDF = async (requestBody: QuotePdfServiceRequest, urlBranch: string) => {

  try {
    const response = await QuotationService.getQuoteDocumentPDF(requestBody, urlBranch);
    if (!response || !response?.base64) {
      throw new Error("Respuesta inválida de getQuoteDocumentPDF");
    }
    const base64 = response?.base64;
    const fileName = documentPdfName(requestBody, urlBranch);
    downloadBase64Files(base64, fileName, FILE_TYPES.PDF);

    return response;
  } catch (error) {
    console.error("Error al obtener PDF Cotizacion:", error);
    return null;
  }
};

export const getQuoteDocumentBase64 = async (requestBody: QuotePdfServiceRequest, urlBranch: string): Promise<{ base64: string; fileName: string } | null> => {

  try {
    const response = await QuotationService.getQuoteDocumentPDF(requestBody, urlBranch);
    if (!response || !response?.base64) {
      throw new Error("Respuesta inválida de getQuoteDocumentPDF");
    }
    const base64 = response?.base64;
    const fileName = documentPdfName(requestBody, urlBranch);
    return { base64, fileName }

  } catch (error) {
    throw new Error("Error al obtener PDF Cotizacion Base64.");
  }
};

export const documentPdfName = (requestBody: QuotePdfServiceRequest, urlBranch: string): string => {
  const timestamp = new Date().toISOString().replace(/[-:T.Z]/g, '');
  switch (urlBranch) {
    case BranchDocumentsURL.INCENDIO:
      return `CotizacionIncendio_${requestBody.presupuestoIncendio?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.ROBO:
      return `CotizacionRobo_${requestBody.presupuestoRobo?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.INTEGRAL_CONSORCIO:
      return `CotizacionIntegralConsorcio_${requestBody.presupuestoConsorcio?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.EFECTOS_PERSONALES:
      return `CotizacionEfectosPersonales_${requestBody.presupuestoRv?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.AP:
      return `CotizacionAccidentesPersonales_${requestBody.presupuestoAccidentesPersonales?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.RESPONSABILIDAD_CIVIL:
      return `CotizacionResponsabilidadCivil_${requestBody.presupuestoRc?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.INTEGRAL_COMERCIO:
      return `CotizacionIntegralComercio_${requestBody.presupuestoComercio?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.AUTOMOVILES:
      return `CotizacionAutomoviles_${requestBody.presupuestoAutos?.numeroCotizacion}_${timestamp}.pdf`;

    case BranchDocumentsURL.HOGAR:
      return `CotizacionHogar_${requestBody.presupuestoHogar?.numeroCotizacion}_${timestamp}.pdf`;

    default:
      return '';
  }
};

export const findLabelByCode = (code: any, list: any) => {
  return list?.find((r: any) => r.value === code).label;
}

export const findCarBrandByYear = (brandCode: any, list: any, yearParam: any): string | undefined => {
  const brandsYear = list.find((item: any) => String(item.year) === String(yearParam));
  if (!brandsYear) return undefined;
  const brand = brandsYear.brands.find((b: any) => b.value === brandCode);
  return brand?.label;
}

export const findCarModelByBrand = (modelCode: any, list: any, brandCode: any): string | undefined => {
  const brandEntry = list.find((item: any) => item.brand === brandCode);
  if (!brandEntry) return undefined;
  const model = brandEntry.models.find((m: any) => m.value === modelCode);
  return model?.label;
};

export const findCarVersionModelByBrand = (versionCode: any, list: any, brandCode: any, modelCode: any, year: any): Version | undefined => {
  const match = list.find((item: any) =>
    item.brand === String(brandCode) &&
    item.model === String(modelCode) &&
    (!year || item.year === String(year))
  );
  if (!match) return undefined;
  const version = match.versions?.find((v: any) => v.codigoVersion === String(versionCode));
  return version;
};

export const findPaymentMethodByCode = (code: any, list: any): PaymentMethodForms => {
  const [codigoFormaDePago, nroPlanDePago] = code.split('-');
  return list?.find(
    (item: { codigoFormaDePago: any; nroPlanDePago: any; }) =>
      item.codigoFormaDePago === codigoFormaDePago &&
      item.nroPlanDePago === nroPlanDePago
  );
}

export const findhousingTypeLabelByCode = (codeHousingType: any, housingTypeOptionsPerPlan: any, planSelected: any) => {
  const housingTypesOptions = housingTypeOptionsPerPlan.find((el: { plan: any; }) => String(el.plan) === String(planSelected))?.housingTypes;
  return housingTypesOptions?.find((r: any) => r.value === codeHousingType).label;
}

export const findCoverageLabelByCode = (codeCoverage: any, allCoveragesPerPlan: any, planSelected: any) => {
  const coverageOptions = allCoveragesPerPlan.find((el: { plan: any; }) => String(el.plan) === planSelected)?.coverages;
  return coverageOptions.find((r: any) => r.codigo === codeCoverage)?.descripcionLarga;
}

export const findLocalityLabelByCode = (provinceCode: any, codeLocality: any, allLocalitiesPerProvince: any) => {
  const localitiesOptions = allLocalitiesPerProvince.find((el: { provinceCode: any; }) => String(el.provinceCode) === String(provinceCode))?.localitiesOptions
  const loc = localitiesOptions?.find((r: any) => r.value === codeLocality);
  return loc.label;
}


/** Aplicable a BIENES de rama HOGAR: recorre todos los tabs/ubicaciones cotizados,
 *  matcheando cada uno con su componente real de la respuesta por nroDeComponente */
export const transformToHoldingHogar = (ctx: QuotationContextData): Holding[] => {
  const tabKeys = ctx.tabs?.length ? ctx.tabs.map((tab) => tab.key) : [ctx.activeKey];

  const componentes = ctx.quotationResponse?.componentes?.length
    ? ctx.quotationResponse.componentes
    : ctx.quotationResponseClosedInfo?.componentes;

  return tabKeys.map((tabKey) => {
    const plan = ctx.stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`) ?? ctx.planSelectedSummary;
    const typeHousing = ctx.stepTwoForm?.getFieldValue(`type-housing-tab-${tabKey}`);
    const component = componentes?.find((c: any) => String(c.nroDeComponente) === String(tabKey)) ?? componentes?.[0];
    const homeQuotationComponent = ctx.homeQuotationComponents?.find((c: any) => String(c.nroComponente) === String(tabKey)) ?? ctx.homeQuotationComponents?.[0];

    return {
      tipoDeVivienda: typeHousing ? findhousingTypeLabelByCode(typeHousing, ctx.housingTypeOptionsPerPlan, plan) : '',
      provincia: findLabelByCode(ctx.stepTwoForm?.getFieldValue(`province-tab-${tabKey}`), ctx.provinceList),
      plan: findLabelByCode(plan, ctx.planOptionsBySelectedPlan),
      localidad: findLocalityLabelByCode(ctx.stepTwoForm?.getFieldValue(`province-tab-${tabKey}`), ctx.stepTwoForm?.getFieldValue(`location-tab-${tabKey}`), ctx.allLocalitiesPerProvince),
      texto: ctx.stepTwoForm?.getFieldValue(`explanatory-text-tab-${tabKey}`) ?? '',
      caracteristicasAplicadas: transformToAppliedCharacteristicsList(homeQuotationComponent?.caracteristicasBien ?? []),
      coberturas: component?.coberturas
        ? component.coberturas.map((cobertura: any) => ({
          cobertura: findCoverageLabelByCode(cobertura.codigoCobertura, ctx.allCoveragesPerPlan, plan),
          sumaAsegurada: parseFloat(cobertura.sumaAsegurada),
          subCategoriaDeTextos: cobertura.subCategoriaDeTextos,
        }))
        : [],
    };
  });
};

/** Aplicable a BIENES de toda las ramas, menos auto (ver transformToHoldingCar) y hogar (ver transformToHoldingHogar).
 *  Recorre todos los tabs/ubicaciones cotizados; si la rama no informa tabs usa solo el activo. */
export const transformToHolding = (ctx: QuotationContextData): Holding[] => {
  // Si no hay tabs en el contexto (p.ej. cotización recargada) se usan los componentes cotizados de la respuesta
  const quotedKeys = ctx.quotationResponse?.componentes?.map((c: any) => c.nroDeComponente) ?? [];
  const tabKeys = ctx.tabs?.length ? ctx.tabs.map((tab) => tab.key) : (quotedKeys.length ? quotedKeys : [ctx.activeKey]);
  return tabKeys.map((tabKey: string | number | undefined) => transformToHoldingByTab(ctx, tabKey));
};

const transformToHoldingByTab = (ctx: QuotationContextData, tabKey?: string | number): Holding => {
  const byBranch = ctx.branchDocumentsURL;
  const getTabValue = (form: any, field: string) => form?.getFieldValue(`${field}-tab-${tabKey}`);
  const findComponent = (components: any[] | undefined) =>
    components?.find((c: any) => String(c.nroComponente) === String(tabKey)) ?? components?.[0];

  return {
    ...(byBranch === BranchDocumentsURL.INCENDIO ? {
      provincia: findLabelByCode(getTabValue(ctx.stepThreeForm, 'province'), ctx.provinceList),
      plan: findLabelByCode(getTabValue(ctx.stepThreeForm, 'plan'), ctx.plansByActivityList),
      localidad: findLocalityLabelByCode(getTabValue(ctx.stepThreeForm, 'province'), getTabValue(ctx.stepThreeForm, 'location'), ctx.allLocalitiesPerProvince),
      actividadComercial: ctx.rubricSelected.descripcionLarga,
      caracteristicasAplicadas: transformToAppliedCharacteristicsList(findComponent(ctx.fireQuotationComponents)?.caracteristicasBien ?? []),
    } : {}),

    ...((byBranch === BranchDocumentsURL.RESPONSABILIDAD_CIVIL)
      || (byBranch === BranchDocumentsURL.ROBO)
      || (byBranch === BranchDocumentsURL.EFECTOS_PERSONALES) ? {
      provincia: findLabelByCode(getTabValue(ctx.stepTwoForm, 'province'), ctx.provinceList),
      plan: findLabelByCode(getTabValue(ctx.stepTwoForm, 'plan'), ctx.planOptionsBySelectedPlan),
      localidad: findLocalityLabelByCode(getTabValue(ctx.stepTwoForm, 'province'), getTabValue(ctx.stepTwoForm, 'location'), ctx.allLocalitiesPerProvince),
      mostrarAdicionalAp: 'false',
      mostrarAdicionalRc: 'false'
    } : {}),

    ...(byBranch === BranchDocumentsURL.INTEGRAL_CONSORCIO ? {
      provincia: findLabelByCode(getTabValue(ctx.stepTwoForm, 'province'), ctx.provinceList),
      plan: findLabelByCode(getTabValue(ctx.stepTwoForm, 'plan'), ctx.planOptionsBySelectedPlan),
      localidad: findLocalityLabelByCode(getTabValue(ctx.stepTwoForm, 'province'), getTabValue(ctx.stepTwoForm, 'location'), ctx.allLocalitiesPerProvince),
      texto: getTabValue(ctx.stepTwoForm, 'explanatory-text'),
      caracteristicasAplicadas: transformToAppliedCharacteristicsList(findComponent(ctx.consortiumQuotationComponents)?.caracteristicasBien ?? []),
    } : {}),

    ...(byBranch === BranchDocumentsURL.INTEGRAL_COMERCIO ? {
      provincia: findLabelByCode(getTabValue(ctx.stepThreeForm, 'province'), ctx.provinceList),
      plan: findLabelByCode(getTabValue(ctx.stepThreeForm, 'plan'), ctx.plansByActivityList),
      localidad: findLocalityLabelByCode(getTabValue(ctx.stepThreeForm, 'province'), getTabValue(ctx.stepThreeForm, 'location'), ctx.allLocalitiesPerProvince),
      actividadComercial: ctx.rubricSelected.descripcionLarga,
      texto: getTabValue(ctx.stepThreeForm, 'explanatory-text'),
      caracteristicasAplicadas: transformToAppliedCharacteristicsList(findComponent(ctx.commerceQuotationComponents)?.caracteristicasBien ?? []),
    } : {}),

    coberturas: transformToCoverageList(ctx, tabKey),
  };
};

/** Aplicable para ACCIDENTES PERSONALES */
export const transformToActivity = (ctx: QuotationContextData): Activity[] => {
  return ctx.quotationResponse.actividades.map((actividad: any) => ({
    plan: findLabelByCode(ctx.propertyDataForm?.getFieldValue(`plans`), ctx.productsList),
    coberturas: transformToCoverageListAP(ctx, actividad),
    descripcion: findLabelByCode(actividad.codigo, ctx.apActiviesListOptions),
    cantidad: actividad.cantidad,
    parentesco: findLabelByCode(actividad.parentesco, ctx.relationshipList),
    edades: findLabelByCode(actividad.rangoDeEdad, ctx.ageRangeList),
  }));
};

/** APLICABLE PARA ACCESORIOS DE AUTOS */
export const addAccessoryValues = (ctx: QuotationContextData): number => {
  const accesorios = ctx.quoatationInfoRequest?.accesorios ?? [];

  if (!Array.isArray(accesorios) || accesorios.length === 0) { return 0; }

  return accesorios.reduce((sum: number, item: any) => {
    const valor = Number(item.accesorioValor);
    return sum + (isNaN(valor) ? 0 : valor);
  }, 0);
};

/** Aplicable a BIENES de rama AUTOS */
export const transformToHoldingCar = (ctx: QuotationContextData): Holding[] => {

  const brandCode = ctx.stepTwoForm?.getFieldValue(`brand-tab-${ctx.activeKey}`) || ctx.stepThreeForm?.getFieldValue(`brand-tab-${ctx.activeKey}`);
  const modelCode = ctx.stepTwoForm?.getFieldValue(`model-tab-${ctx.activeKey}`) || ctx.stepThreeForm?.getFieldValue(`model-tab-${ctx.activeKey}`);
  const versionCode = ctx.stepTwoForm?.getFieldValue(`version-tab-${ctx.activeKey}`);
  const year = String(
    ctx.stepTwoForm?.getFieldValue(`vehicleYear-tab-${ctx.activeKey}`) ??
      ctx.stepThreeForm?.getFieldValue(`vehicleYear-tab-${ctx.activeKey}`) ??
      ''
  );

  return [{
    marca: findCarBrandByYear(brandCode, ctx.brandsByYear, year),
    modelo: findCarModelByBrand(modelCode, ctx.modelsByBrandAndYear, brandCode)
      + ' (' + findCarVersionModelByBrand(versionCode, ctx.versionsByYearBrandAndModel, brandCode, modelCode, year)?.descripcion + ')',
    anio: year,
    sumaAccesorios: addAccessoryValues(ctx),
    sumaAsegurada: ctx.quoatationInfoRequest?.valorAsegurado,
    combustible: (ctx.stepTwoForm?.getFieldValue(`gnc-tab-${ctx.activeKey}`)) === 'S' ? 'GNC' : 'Nafta',
    codigoPostal: ctx.clientSelected?.codigoPostal,
    coberturas: transformToCoverageListCar(ctx)
  }];
};
/* APLICABLE PARA LAS CARACTERISTICAS APLICADAS DE TODAS LAS RAMAS */
export const transformToAppliedCharacteristicsList = (caracteristicasBien: any): AppliedCharacteristics[] => {
  if (!caracteristicasBien.length) return [];

  return caracteristicasBien
    .filter((caracteristica: any) => caracteristica.tiene === "S")
    .map((caracteristicasBien: any) => ({
      codigo: caracteristicasBien.codigo,
      caracteristica: caracteristicasBien.descripcion
    }));
};

/* APLICABLE PARA LAS COBERTURAS DE TODAS LAS RAMAS, menos auto,Hogar y AP.
 * Toma el componente de la respuesta que corresponde al tab (nroDeComponente) */
export const transformToCoverageList = (ctx: QuotationContextData, tabKey?: string | number): Coverage[] => {
  tabKey = tabKey ?? ctx.activeKey;
  const plan = ctx.stepThreeForm?.getFieldValue(`plan-tab-${tabKey}`) || ctx.stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);
  const componentes = ctx.quotationResponse?.componentes;
  if (!componentes?.length) return [];
  const component = componentes.find((c: any) => String(c.nroDeComponente) === String(tabKey)) ?? componentes[0];
  if (!component?.coberturas) return [];
  return component.coberturas.map((cobertura: any) => ({
    cobertura: findCoverageLabelByCode(cobertura.codigoCobertura, ctx.allCoveragesPerPlan, plan),
    sumaAsegurada: parseFloat(cobertura.sumaAsegurada),
    subCategoriaDeTextos: cobertura.subCategoriaDeTextos
  }));
};


/* APLICABLE PARA COBERTURAS de ACCIDENTES PERSONALES, por ACTIVIDAD */
export const transformToCoverageListAP = (ctx: QuotationContextData, activity: Activity): Coverage[] => {
  if (!activity || !activity?.coberturas) return [];
  return activity.coberturas.map((cobertura: any) => ({
    cobertura: findCoverageLabelByCode(cobertura.cobertura, ctx.allCoveragesPerPlan, ctx.propertyDataForm?.getFieldValue(`plans`)),
    sumaAsegurada: formattedPrice(cobertura.sumaAsegurada),
    subCategoriaDeTextos: cobertura.subCategoriaDeTextos
  }));
};

/* APLICABLE PARA REBAJAS Y RECARGOS DE RAMA AUTOS */
export const transformToDiscountsAndSurchargesList = (ctx: any): DiscountsAndSurcharges[] => {
  return ctx.coverageSelectedByVehicle[0]?.coverageSelected.factoresMultiplicativos.map((factor: any) => ({
    codigo: factor.codigo,
    descripcion: factor.descripcion
  }));
};

/** RETURNA SI LA COBERTURA FUE SELECCIONADA */
export const findSelectedCoverageCar = (ctx: any, coverageCode: any): boolean => {
  const selectedCoverage = ctx.coverageSelectedByVehicle?.[0]?.coverageSelected;
  if (!selectedCoverage) return false;
  return selectedCoverage.codigo === coverageCode;
}

/** CALCULA LA CUOTA INICIAL SEGUN EL TIPO DE REPORTE, A FUTURO LLEGARÁ DE UN SERVICIO*/
export const returnInitialInstallment = (premio: number, tipoRepore: any) => {
  let result = 0;
  switch (tipoRepore) {
    case 'SEM':
      result = premio / 6;
      break;
    case 'CUA':
      result = premio / 4;
      break;
    case 'MYW':
      result = premio;
      break;
    default:
      result = 0;
  }
  return Number(result.toFixed(2));
}

const CAR_FRANQUICIA_INUNDACION_NACIONAL = 421600;
const CAR_FRANQUICIA_INUNDACION_IMPORTADO = 894700;

const CAR_INUNDACION_FRANCHISE_EXEMPT_CODES = new Set<string>(
  Object.values(CarCoverageInundacionFranchiseExempt)
);

/** Monto de franquicia inundación para PDF de Autos **/
/** 0 si la cobertura no aplica (A/C). Valores fijos hasta servicio futuro. Deuda técnica pendiente */
const resolveCarFranquiciaInundacion = (
  coverageCode: unknown,
  ctx: QuotationContextData
): number => {
  const normalized = String(coverageCode ?? "").toUpperCase();
  if (CAR_INUNDACION_FRANCHISE_EXEMPT_CODES.has(normalized)) {
    return 0;
  }
  const origin = ctx.stepTwoForm?.getFieldValue(`origin-tab-${ctx.activeKey}`);
  return origin === "NACIONAL"
    ? CAR_FRANQUICIA_INUNDACION_NACIONAL
    : CAR_FRANQUICIA_INUNDACION_IMPORTADO;
};

/* APLICABLE PARA LAS COBERTURAS DE AUTOS */
export const transformToCoverageListCar = (ctx: QuotationContextData): Coverage[] => {

  const vehicleData =
    ctx.reQuotationResponseByCar?.find(
      (el: any) => String(el.componentId) === String(ctx.activeKey)
    ) ??
    ctx.quotationResponseByCar?.find(
      (el: any) => String(el.componentId) === String(ctx.activeKey)
    ) ??
    null;


  const coberturas = vehicleData?.reQuotationResponse?.coberturas ?? vehicleData?.quotationResponse?.coberturas;

  if (!coberturas) return [];
  return coberturas.map((cobertura: any) => ({
    cobertura: cobertura.codigo,
    coberturaElegida: findSelectedCoverageCar(ctx, cobertura.codigo),
    cuotaInicial: returnInitialInstallment(cobertura.premio, ctx.allArticleSelected?.tipoReporte), //SE OBTENDRÁ DE UN SERVICIO A FUTURO
    franquiciaInundacion: resolveCarFranquiciaInundacion(cobertura.codigo, ctx),
    franquiciaDanioParcial: cobertura.importeFranquicia,
    clausulaMantenimiento: cobertura.porcentajeClausulaDeAjuste || 0,
    prima: cobertura.prima || 0,
    extraPrimaVariable: cobertura.importesCobertura?.porcentajeExtraPrimaVariable || 0,
    comision: cobertura.importesCobertura?.porcentajeDeComision || 0,
    rebajasRecargos: transformToDiscountsAndSurchargesList(ctx),
    subCategoriaDeTextos: cobertura.subCategoriaDeTextos,
  }));
};

export const transformToBudgetFire = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationForm?.token),
  tipoPresupuesto: budgetType,
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  premio: formattedPrice(ctx.quotationResponse?.premio),
  comision: formattedPrice(ctx.quotationResponse?.condicionesComerciales.impComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.prima),
  extraPrimaFija: formattedPrice(ctx.quotationResponse?.impuestos.impExtraPrimaFija),
  extraPrimaVariable: formattedPrice(ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar),
  recargoFinanciero: Number(ctx.quotationResponse?.impuestos.impRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premio),
  medioDePago: findPaymentMethodByCode(ctx.firePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.firePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  bienes: transformToHolding(ctx),
});

export const transformToBudgetTheft = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationInfo?.token),
  tipoPresupuesto: budgetType,
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  premio: formattedPrice(ctx.quotationResponse?.premio),
  comision: formattedPrice(ctx.quotationResponse?.condicionesComerciales.impComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.prima),
  extraPrimaFija: formattedPrice(ctx.quotationResponse?.impuestos.impExtraPrimaFija),
  extraPrimaVariable: formattedPrice(ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar),
  recargoFinanciero: Number(ctx.quotationResponse?.impuestos.impRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premio),
  medioDePago: findPaymentMethodByCode(ctx.theftInsurancePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.theftInsurancePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  bien: transformToHolding(ctx)[0],
});

export const transformToBudgetCivilResponsability = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationInfo?.token),
  tipoPresupuesto: budgetType,
  // fechaDesde: '', //NO APLICA
  // fechaHasta: '', //NO APLICA
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  premio: formattedPrice(ctx.quotationResponse?.premio),
  comision: formattedPrice(ctx.quotationResponse?.condicionesComerciales.impComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.prima),
  extraPrimaFija: formattedPrice(ctx.quotationResponse?.impuestos.impExtraPrimaFija),
  extraPrimaVariable: formattedPrice(ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar),
  recargoFinanciero: Number(ctx.quotationResponse?.impuestos.impRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premio),
  medioDePago: findPaymentMethodByCode(ctx.civilPaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.civilPaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  bien: transformToHolding(ctx)[0],
});

export const transformToBudgetPersonalEffects = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationInfo?.token),
  tipoPresupuesto: budgetType,
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  premio: formattedPrice(ctx.quotationResponse?.premio),
  comision: formattedPrice(ctx.quotationResponse?.condicionesComerciales.impComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.prima),
  extraPrimaFija: formattedPrice(ctx.quotationResponse?.impuestos.impExtraPrimaFija),
  extraPrimaVariable: formattedPrice(ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar),
  recargoFinanciero: Number(ctx.quotationResponse?.impuestos.impRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premio),
  medioDePago: findPaymentMethodByCode(ctx.personalEffectsPaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.personalEffectsPaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  bien: transformToHolding(ctx)[0],
});

export const transformToBudgetConsortiumIntegral = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationInfo?.token),
  tipoPresupuesto: budgetType,
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  premio: formattedPrice(ctx.quotationResponse?.premio),
  comision: formattedPrice(ctx.quotationResponse?.condicionesComerciales.impComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.prima),
  extraPrimaFija: formattedPrice(ctx.quotationResponse?.impuestos.impExtraPrimaFija),
  extraPrimaVariable: formattedPrice(ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar),
  recargoFinanciero: Number(ctx.quotationResponse?.impuestos.impRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premio),
  medioDePago: findPaymentMethodByCode(ctx.consortiumPaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.consortiumPaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  inspeccion: false, //No aplica
  bienes: transformToHolding(ctx),
});

export const transformToBudgetHomeProduct = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationInfo?.token),
  tipoPresupuesto: budgetType,
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  premio: formattedPrice(ctx.quotationResponse?.premio ?? ctx.quotationResponseClosedInfo.premio),
  comision: ctx.quotationResponse?.condicionesComerciales.impComision != null ? formattedPrice(ctx.quotationResponse?.condicionesComerciales.impComision) : formattedPrice(ctx.quotationResponseClosedInfo?.componentes[0]?.impuestos[0]?.impComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.prima ?? ctx.quotationResponseClosedInfo.prima),
  extraPrimaFija: ctx.quotationResponse?.impuestos.impExtraPrimaFija != null ? formattedPrice(ctx.quotationResponse?.impuestos.impExtraPrimaFija) : formattedPrice(ctx.quotationResponseClosedInfo?.componentes[0]?.impuestos[0]?.impExtraPrimaFija),
  extraPrimaVariable: ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar != null ? formattedPrice(ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar) : formattedPrice(ctx.quotationResponseClosedInfo?.componentes[0]?.impuestos[0]?.impExtraPrimaVar),
  recargoFinanciero: ctx.quotationResponse?.impuestos.impRecargoFinanciero ? Number(ctx.quotationResponse?.impuestos.impRecargoFinanciero) : Number(ctx.quotationResponseClosedInfo?.componentes[0]?.impuestos[0]?.porcRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premio),
  medioDePago: findPaymentMethodByCode(ctx.homePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.homePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  inspeccion: (ctx.quotationResponse?.componentes[0]?.requiereInspeccion === 'S') ? true : false,
  bienes: transformToHoldingHogar(ctx),
});

//PENDIENTE PRUEBA POR COMBO RUBRO
export const transformToBudgetCommerce = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationInfo?.token),
  tipoPresupuesto: budgetType,
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  premio: formattedPrice(ctx.quotationResponse?.premio),
  comision: formattedPrice(ctx.quotationResponse?.condicionesComerciales.impComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.prima),
  extraPrimaFija: formattedPrice(ctx.quotationResponse?.impuestos.impExtraPrimaFija),
  extraPrimaVariable: formattedPrice(ctx.quotationResponse?.componentes[0]?.impuestos[0].impExtraPrimaVar),
  recargoFinanciero: Number(ctx.quotationResponse?.impuestos.impRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premio),
  medioDePago: findPaymentMethodByCode(ctx.commercePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.commercePaymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  bienes: transformToHolding(ctx),
});

export const transformToBudgetAP = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationForm?.token),
  tipoPresupuesto: budgetType,
  vigenciaDesde: dayjs(ctx.quotationForm?.vigenciaDesde).format('DD/MM/YYYY'),
  vigenciaHasta: dayjs(ctx.quotationForm?.vigenciaHasta).format('DD/MM/YYYY'),
  cantidadDias: ctx.propertyDataForm?.getFieldValue('quantityOfDays'),
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  sumaAsegurada: formattedPrice(ctx.quotationResponse?.totalSumaAsegurada),
  prima: ctx.quotationResponse?.primaOperacion,
  premio: formattedPrice(ctx.quotationResponse?.premioOperacion),
  comision: formattedPrice(ctx.quotationResponse?.primaPremioOperacion.importeComision),
  primaTecnica: formattedPrice(ctx.quotationResponse?.primaOperacion),
  extraPrimaFija: formattedPrice(ctx.quotationResponse?.primaPremioOperacion.importeExtraPrimaFija),
  extraPrimaVariable: formattedPrice(ctx.quotationResponse?.primaPremioOperacion.extraPrimaVariable),
  recargoFinanciero: Number(ctx.quotationResponse?.primaPremioOperacion.importeRecargoFinanciero),
  costoAnual: formattedPrice(ctx.quotationResponse?.premioOperacion),
  medioDePago: findPaymentMethodByCode(ctx.paymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  cantidadDeCuotas: Number(findPaymentMethodByCode(ctx.paymentMethodsForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).cantCuotas),
  actividades: transformToActivity(ctx),
});

const transformToMyWayScoring = (ctx: QuotationContextData) =>
  (ctx.scoringQuestions ?? []).map(({ codigo, descripcion }: { codigo: string; descripcion: string }) => ({
    pregunta: descripcion,
    respuesta:
      ctx.stepTwoForm?.getFieldValue(`${codigo}-tab-${ctx.activeKey}`) === 'S',
  }));

export const transformToBudgetCar = (ctx: QuotationContextData, budgetType: BudgetType): Budget => ({
  numeroCotizacion: Number(ctx.quotationInfo?.token),
  tipoPresupuesto: budgetType,
  tipoReporte: ctx.allArticleSelected?.tipoReporte,
  solicitante: ctx.clientSelected?.nombre,
  provincia: findLabelByCode(ctx.clientSelected?.codProvincia, ctx.provinceList),
  situacionIva: findLabelByCode(ctx.clientSelected?.condicionIVA, ctx.ivaConditionList),
  medioDePago: findPaymentMethodByCode(ctx.stepThreeForm?.getFieldValue('paymentMethod'), ctx.paymentMethodsList).descripcion,
  ...(ctx.allArticleSelected?.tipoReporte === 'MYW'
    ? { scoring: transformToMyWayScoring(ctx) }
    : {}),
  bienes: transformToHoldingCar(ctx)
});


/**
 * GENERACIÓN DE REQUEST BODY PARA GENERACION DE PDF COTIZACION
 * @param ctx 
 * @param budgetType 
 * @returns 
 */
export const transformToPdfQuote = (ctx: QuotationContextData, budgetType: BudgetType): QuotePdfServiceRequest => {
  switch (ctx.branchDocumentsURL) {
    case BranchDocumentsURL.INCENDIO:
      return {
        presupuestoIncendio: transformToBudgetFire(ctx, budgetType),
      };
    case BranchDocumentsURL.ROBO:
      return {
        presupuestoRobo: transformToBudgetTheft(ctx, budgetType),
      };
    case BranchDocumentsURL.INTEGRAL_CONSORCIO:
      return {
        presupuestoConsorcio: transformToBudgetConsortiumIntegral(ctx, budgetType),
      };
    case BranchDocumentsURL.EFECTOS_PERSONALES:
      return {
        presupuestoRv: transformToBudgetPersonalEffects(ctx, budgetType),
      };
    case BranchDocumentsURL.AP:
      return {
        presupuestoAccidentesPersonales: transformToBudgetAP(ctx, budgetType),
      };
    case BranchDocumentsURL.RESPONSABILIDAD_CIVIL:
      return {
        presupuestoRc: transformToBudgetCivilResponsability(ctx, budgetType),
      };
    case BranchDocumentsURL.INTEGRAL_COMERCIO:
      return {
        presupuestoComercio: transformToBudgetCommerce(ctx, budgetType),
      };
    case BranchDocumentsURL.AUTOMOVILES:
      return {
        presupuestoAutos: transformToBudgetCar(ctx, budgetType),
      };
    case BranchDocumentsURL.HOGAR:
      return {
        presupuestoHogar: transformToBudgetHomeProduct(ctx, budgetType),
      };
    default:
      throw new Error(`Tipo de RAMA no soportado: ${ctx.branchDocumentsURL}`);
  }
};
